var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { withDefault } from '../../../utils/serializr/schema/middle/withDefault';
import { memoize } from '../../../utils/mobx/decorators/memoize';
import { deserialize, list, object } from '../../../utils/serializr/serializr';
import { editable, editObservable } from '../../../utils/mobx/decorators/editable';
import { SortableStoreStateItem } from './SortableStoreStateItem';
export class SortableStoreStateOverall {
    parent;
    sortableItemStates;
    constructor({ parent }) {
        editObservable(this);
        this.parent = parent;
    }
    get question() {
        return this.parent;
    }
    static fromSerialized(ser = {}) {
        return deserialize(SortableStoreStateOverall, ser);
    }
    static get serializeInfo() {
        return {
            props: {
                sortableItemStates: withDefault(list(object(SortableStoreStateItem)), []),
            },
        };
    }
}
__decorate([
    editable('shallow')
], SortableStoreStateOverall.prototype, "sortableItemStates", void 0);
__decorate([
    memoize
], SortableStoreStateOverall, "serializeInfo", null);
